class RegistrationConfirmationController {
  constructor ($state, $stateParams, I18n) {
    'ngInject'
    this.$state = $state
    this.I18n = I18n
    this.$stateParams = $stateParams
    if (this.$stateParams.email) {
      this.email = this.$stateParams.email
    } else {
      this.$state.go('registration')
    }
  }
}

export default RegistrationConfirmationController



// WEBPACK FOOTER //
// ./src/app/pages/registration-confirmation/registration-confirmation.controller.js